export default __webpack_public_path__ + "static/media/7.f3709530.jpg";